import React, { useState } from 'react'
import { useFormContext } from "react-hook-form"
import { Grid } from '@material-ui/core'
import ReactivateUserApiUrls from 'src/apiUrls/ReactivateUserApiUrls.js'
import Namespace from 'src/constants/locale/Namespace'
import ReactivateUserKeys from '../../constants/locale/key/ReactivateUser'
import makeValidationSchema from './MakeValidationSchema'
import CngBackdrop from 'src/components/cngcomponents/CngBackDrop'
import ReactivateUserButtonComponent from './component/ReactivateUserButtonComponent'
import CngSection from '../../components/cngcomponents/CngSection'

import {
  components,
  DataFlattener,
  useServices,
  useTranslation,
} from 'cng-web-lib'

const {
  form: { field: { CngTextField } },
  CngGridItem
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({ userId: "" })

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ disabled, showNotification, shouldHideMap }) {
  const { getValues, trigger } = useFormContext();
  const { securedSendRequest } = useServices();
  const { translate } = useTranslation(Namespace.REACTIVATE_USER)
  const translatedTextsObject = makeTranslatedTextsObject()

  const [loadingState, setLoadingState] = new useState(false);

  function makeTranslatedTextsObject() {
    let title = translate(
      Namespace.REACTIVATE_USER,
      ReactivateUserKeys.TITLE
    )

    let userId = translate(
      Namespace.REACTIVATE_USER,
      ReactivateUserKeys.USER_ID
    )

    let successMessage = translate(
      Namespace.REACTIVATE_USER,
      ReactivateUserKeys.SUCCESS_MESSAGE
    )

    let errorMessage = translate(
      Namespace.REACTIVATE_USER,
      ReactivateUserKeys.ERROR_MESSAGE
    )

    let errorMessageEmptyUserId = translate(
      Namespace.REACTIVATE_USER,
      ReactivateUserKeys.ERROR_MESSAGE_EMPTY_USER_ID
    )

    return {
      title,
      userId,
      successMessage,
      errorMessage,
      errorMessageEmptyUserId
    }
  }

  function onSubmit() {
    const result = trigger()

    result.then(function (result) {
      if (result == true) {
        setLoadingState(true)
        let userId = getValues("userId")

        if (userId !== null && userId.length > 0) {
          const data = { "userId": userId }

          function onSuccess(response) {
            let data = response.data;

            if (response.status == 200 && data) {
              let error = data.errorMessages;
              if (!error || error.length === 0) {
                showNotification("success", translatedTextsObject.successMessage)
              } else {
                showNotification("error", error)
              }
            }else{
              showNotification("error", translatedTextsObject.errorMessage)
            }
          }

          function onError(error) {
            console.error('Error', error)
            showNotification("error", translatedTextsObject.errorMessage)
          }

          function onComplete() {
            setLoadingState(false)
          }

          const config = {}
          securedSendRequest.execute('POST', ReactivateUserApiUrls.REACTIVATE, data, onSuccess, onError, onComplete, config, null);
        } else {
          setLoadingState(false)
          showNotification("error", translatedTextsObject.errorMessageEmptyUserId)
        }
      }
    });
  }

  return loadingState ? (
    <CngBackdrop loading />
  ) : (
    <CngSection title={translatedTextsObject.title}>
      <Grid container justify='flex-end' spacing={2}>
        <CngGridItem xs={12}>
          <Grid container spacing={2}>
            <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.userId}>
              <CngTextField
                name='userId'
                label={translatedTextsObject.userId}
                disabled={disabled}
              />
            </CngGridItem>
          </Grid>
        </CngGridItem>
        <CngGridItem xs='auto'>
          <ReactivateUserButtonComponent onSubmit={onSubmit} />
        </CngGridItem>
      </Grid>
    </CngSection>
  )
}

function toClientDataFormat(serverData) {
  let localData = DataFlattener.parse(serverData);
  return localData;
}

function toServerDataFormat(localData) {
  return DataFlattener.unflatten(localData);
}

const FormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields,
  toClientDataFormat: toClientDataFormat,
  toServerDataFormat: toServerDataFormat
})

export default FormProperties;
